var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { parseNumberToLocale } from '../../helpers/numberFormatter';
import { InnerInput } from './APInput';
import BigNumber from 'bignumber.js';
var separators = ['.', ','];
var InnerNumberInput = function (_React$Component) {
  _inherits(InnerNumberInput, _React$Component);
  function InnerNumberInput() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, InnerNumberInput);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InnerNumberInput.__proto__ || Object.getPrototypeOf(InnerNumberInput)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      displayValue: ''
    }, _this.handleChange = function (e) {
      // custom onChange to parse and validate input value
      // before calling standard onChange from redux-form and customChange (if exists)

      var _this$props = _this.props,
        allowNegative = _this$props.allowNegative,
        customChange = _this$props.customChange;
      var inputValue = e.target.value;
      var value = parseNumberToLocale(inputValue, null, !allowNegative);
      // prevent adding two dots or two commas
      var validSeparator = !inputValue.includes('..') && !inputValue.includes(',,');
      if (!Number.isNaN(value) && _this.validateDecimalPlaces(inputValue) && validSeparator) {
        _this.setState({
          displayValue: inputValue
        });
        _this.props.input.onChange(value);
        if (customChange) {
          customChange(value);
        }
      }
    }, _this.handleFocus = function (e) {
      if (Number(_this.state.displayValue) === 0) {
        _this.setState({
          displayValue: ''
        });
      }
    }, _this.validateDecimalPlaces = function (valueString) {
      var decimalPlaces = _this.props.decimalPlaces;
      if (decimalPlaces >= 0) {
        // Handle multiple zeroes after the comma, valueString contains these
        var decimals = valueString.split('.')[1];
        return !decimals || decimals.length <= decimalPlaces;
      }
      return true;
    }, _this.isSeparator = function (value) {
      return separators.includes(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // state.displayValue and props.input.value aren't in sync. Why:
  // props.input.value - redux-form value from reducer and it is source of truth.
  // state.displayValue - value that shown in input
  // Conditions when input.value and state.displayValue aren't in sync:
  // 1) user prints fractional number:
  // - Imagine user wants to enter 5.9
  //    User enters `5`: reducer (props.input.value) stores `5`, state.displayValue stores `5`
  //    User enters `.`: reducer stores `5` (!!!), state.displayValue stores `5.`
  //    User enters `9`: reducer stores `5.9`, state.displayValue stores `5.9`
  // 2) input change forced from outside by dispatching redux-form's change directly (examples: clearing order form, sync price and quantity)

  _createClass(InnerNumberInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.input.value !== this.props.input.value) {
        // handle forced change based on difference between input.value and displayValue
        // exclude case with entering the separator symbol first
        // keep input.value and displayValue in sync otherwise

        if (this.props.input.value === '' || Number(this.state.displayValue) !== 0 && (Number(this.props.input.value) === 0 || Number.isNaN(Number(this.props.input.value))) && !this.isSeparator(this.state.displayValue)) {
          this.setState({
            displayValue: ''
          });
        } else if (!this.isSeparator(this.state.displayValue)) {
          this.setState({
            displayValue: new BigNumber(this.props.input.value).toFixed()
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        input = _props.input,
        allowNegative = _props.allowNegative,
        customChange = _props.customChange,
        decimalPlaces = _props.decimalPlaces,
        passedProps = _objectWithoutProperties(_props, ['input', 'allowNegative', 'customChange', 'decimalPlaces']);
      return React.createElement(InnerInput, Object.assign({
        step: 'any'
      }, passedProps, {
        autoComplete: 'off',
        type: 'number',
        input: Object.assign({}, input, {
          value: this.state.displayValue,
          onChange: this.handleChange,
          //call onBlur without args so the stored value is not changed
          onBlur: function onBlur() {
            return input.onBlur();
          }
        }),
        onClick: function onClick() {
          input.onFocus();
          _this2.handleFocus('onClick');
        },
        onFocus: function onFocus() {
          input.onFocus();
          _this2.handleFocus('onFocus');
        }
      }));
    }
  }]);
  return InnerNumberInput;
}(React.Component);
var APNumberInput = function APNumberInput(props) {
  return React.createElement(Field, Object.assign({
    name: props.name,
    component: InnerNumberInput
  }, props));
};
APNumberInput.defaultProps = {
  allowNegative: false
};
APNumberInput.propTypes = {
  allowNegative: PropTypes.bool,
  decimalPlaces: PropTypes.number
};
export default APNumberInput;